import { Component, Event, EventEmitter, h, State } from '@stencil/core';
import QRCode from 'qrcode';
import store from '../../../helpers/store';
import Events from '../../../helpers/Events';
import { FlowStatus } from '../../../models/FlowStatus';
import { FlowSteps } from '../../../models/FlowSteps';
import { delay } from '../../../utils/utils';
import { BaseComponent } from '../../base-component';
import { TranslationValues } from '../../../models/ITranslationValues';
import { Translations } from '../../../helpers/TranslationUtils';
import { ApiCall } from '../../../helpers/ApiCall';
import logoOntrace from '../../../assets/logo-ontrace.svg';

@Component({
  tag: 'mobile-redirect',
  styleUrl: 'mobile-redirect.css',
  shadow: false,
})
export class MobileRedirect {
  @State() private infoTextTop: string;
  @State() private infoTextBottom: string;
  @State() private contact: string;
  @State() private invalidValue: boolean;
  @State() private waitingMobile: boolean;
  @State() private orderStatus: FlowStatus;
  @State() private redirectLink: string;
  @State() private qrCode: string;
  @State() private prefilledPhone: boolean = false;
  private translations: TranslationValues;

  @Event({
    eventName: 'apiError',
  })
  apiErrorEvent: EventEmitter<any>;

  constructor() {
    this.invalidValue = false;
    this.waitingMobile = false;
  }

  async componentWillLoad() {
    Events.init(window);
    Events.flowStarted();
    this.translations = await Translations.getValues();
    this.infoTextTop = this.translations.MobileRedirectValues.InfoTop;
    this.infoTextBottom = this.translations.MobileRedirectValues.InfoBottom;
    let envUri = 'ontr';
    if (store.environment == 'QA') {
      envUri = 'test';
    } else if (store.environment == 'DOCKER') {
      envUri = '';
    }
    this.redirectLink = new URL(envUri + '/mobileredirect?redirectId=' + store.redirectId, store.redirectBaseUrl).toString();

    if (store.phoneNumber && store.phoneNumber != '') {
      this.contact = store.phoneNumber;
      this.prefilledPhone = true;
    }

    var self = this;
    QRCode.toDataURL(this.redirectLink, { type: 'image/png', errorCorrectionLevel: 'M', scale: 6 }, function (error, url) {
      if (error) console.error(error);
      self.qrCode = url;
    });
  }

  async componentDidLoad() {
    await BaseComponent.initialize(FlowSteps.MobileRedirect);

    await delay(5000);
    await this.checkStatus();
    while (this.orderStatus != FlowStatus.COMPLETE) {
      await this.checkStatus();
      await delay(5000);
    }
  }

  async checkStatus() {
    this.orderStatus = await ApiCall.instance.GetStatusUi(store.requestId);
    if (this.orderStatus == null) {
      this.apiErrorEvent.emit({ message: 'No order was started for this process.' });
    } else if (this.orderStatus == FlowStatus.ABORTED) {
      this.waitingMobile = false;
      this.infoTextTop = this.translations.MobileRedirectValues.InfoAborted;
      Events.flowAborted();
    } else if (this.orderStatus == FlowStatus.COMPLETE) {
      this.waitingMobile = false;
      store.flowStatus = FlowStatus.COMPLETE;
    } else if (this.orderStatus != FlowStatus.MOBILE) {
      this.infoTextTop = this.translations.MobileRedirectValues.InfoWaiting;
      this.waitingMobile = true;
    }
  }

  async disconnectedCallback() {
    await BaseComponent.finalize(FlowSteps.MobileRedirect);
  }

  async buttonClick() {
    if (this.contact == '' || this.contact.length != 10) {
      this.invalidValue == true;
      return;
    }
    this.waitingMobile = true;
    this.infoTextTop = this.translations.MobileRedirectValues.InfoWaiting;
    try {
      await ApiCall.instance.SendLink(this.redirectLink, this.contact);
    } catch (e) {
      this.apiErrorEvent.emit(e);
    }
  }

  handleChangeContact(ev) {
    let value = ev.target ? ev.target.value : '';
    this.contact = value.replace(/\D/g, '');
    if (this.contact.length > 10) {
      this.contact = this.contact.substring(0, 10);
    }
    this.invalidValue = this.contact.length != 10;
    ev.target.value = this.contact;
  }

  render() {
    return (
      <div class="container flex center">
        <div class="px-2 w-100">
          <div hidden={this.waitingMobile}>
            <h1 class="text-center px-2 mb-1">{this.infoTextTop}</h1>
            <div class="flex center">
              <img src={this.qrCode}></img>
            </div>
            <h2 class="text-center px-2 mb-2">{this.infoTextBottom}</h2>
            <div class="input-container mb-3 px-3">
              <label class="font-size-18 mb-1 color-red" hidden={this.invalidValue == false}>
                <b>{this.translations.MobileRedirectValues.Validation}</b>
              </label>
              <input type="text" id="codeInput" class="main-input" disabled={this.prefilledPhone} value={this.contact} onInput={ev => this.handleChangeContact(ev)} />
            </div>
            <div class="px-3">
              <button class="main-button" onClick={() => this.buttonClick()}>
                {this.translations.MobileRedirectValues.Send}
              </button>
            </div>
          </div>
          <div hidden={this.waitingMobile == false}>
            <div class="text-center">
              <p class="font-size-2">{this.infoTextTop}</p>
            </div>
          </div>
          <div class="footer text-center">
            <img src={logoOntrace}></img>
          </div>
        </div>
      </div>
    );
  }
}
